import React, { useState } from 'react';

/**
 * LazyMenuList component for react-select
 * Implements lazy loading by rendering items in batches of 20
 * Loads more items as user scrolls to the bottom
 */
const LazyMenuList = ({ children, innerRef, innerProps, maxHeight = '200px' }) => {
  const [displayCount, setDisplayCount] = useState(20);
  const childrenArray = React.Children.toArray(children);
  const hasMore = displayCount < childrenArray.length;

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore) {
      setDisplayCount((prev) => prev + 20);
    }
  };

  return (
    <div ref={innerRef} {...innerProps} onScroll={handleScroll} style={{ maxHeight, overflowY: 'auto' }}>
      {childrenArray.slice(0, displayCount)}
    </div>
  );
};

export default LazyMenuList;
